import './contact.css.proxy.js';
/* src/routes/contact.svelte generated by Svelte v3.35.0 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_text,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	text,
	transition_in,
	transition_out
} from "../../web_modules/svelte/internal.js";

import { contact } from "./preload.js";
import { News } from "../../_modules/news/index.js";
import { Car } from "../../_modules/car/index.js";
import Page from "../../_components/slot/Page.js";
import Wrap from "../../_components/slot/Wrap.js";
import Center from "../../_components/slot/Center.js";
import Section from "../../_components/slot/Section.js";
import List from "../../_components/list/List.js";
import Item from "../../_components/list/Item.js";
import Title from "../../_components/block/Title.js";
import ContactForm from "../../_components/contact/ContactForm.js";
import Button from "../../_components/button/Simple.js";
import NewsLink from "../../_components/news/Link.js";
import CarLink from "../../_components/car/LargeLink.js";
import CTA from "../../_components/block/CTA.js";
import CTContact from "../../_components/block/CTContact.js";
import Head from "../../_components/meta/Head.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[5] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[5] = list[i];
	return child_ctx;
}

// (28:331) {#if thanks}
function create_if_block(ctx) {
	let section;
	let current;

	section = new Section({
			props: {
				kind: "top",
				$$slots: { default: [create_default_slot_14] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(section.$$.fragment);
		},
		l(nodes) {
			claim_component(section.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(section, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(section.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(section.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(section, detaching);
		}
	};
}

// (28:363) <Wrap>
function create_default_slot_15(ctx) {
	let p;
	let t;

	return {
		c() {
			p = element("p");
			t = text("お問い合わせが完了しました。返信があるまで今しばらくお待ち下さい。");
			this.h();
		},
		l(nodes) {
			p = claim_element(nodes, "P", { class: true });
			var p_nodes = children(p);
			t = claim_text(p_nodes, "お問い合わせが完了しました。返信があるまで今しばらくお待ち下さい。");
			p_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(p, "class", "thanks svelte-cks03j");
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (28:343) <Section kind="top">
function create_default_slot_14(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_15] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 1024) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (28:461) <Center>
function create_default_slot_13(ctx) {
	let contactform;
	let current;

	contactform = new ContactForm({
			props: {
				endpoint: /*endpoint*/ ctx[2],
				subject: /*subject*/ ctx[1]
			}
		});

	return {
		c() {
			create_component(contactform.$$.fragment);
		},
		l(nodes) {
			claim_component(contactform.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(contactform, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const contactform_changes = {};
			if (dirty & /*endpoint*/ 4) contactform_changes.endpoint = /*endpoint*/ ctx[2];
			if (dirty & /*subject*/ 2) contactform_changes.subject = /*subject*/ ctx[1];
			contactform.$set(contactform_changes);
		},
		i(local) {
			if (current) return;
			transition_in(contactform.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(contactform.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(contactform, detaching);
		}
	};
}

// (28:455) <Wrap>
function create_default_slot_12(ctx) {
	let center;
	let current;

	center = new Center({
			props: {
				$$slots: { default: [create_default_slot_13] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(center.$$.fragment);
		},
		l(nodes) {
			claim_component(center.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(center, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const center_changes = {};

			if (dirty & /*$$scope, endpoint, subject*/ 1030) {
				center_changes.$$scope = { dirty, ctx };
			}

			center.$set(center_changes);
		},
		i(local) {
			if (current) return;
			transition_in(center.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(center.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(center, detaching);
		}
	};
}

// (28:446) <Section>
function create_default_slot_11(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_12] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope, endpoint, subject*/ 1030) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (28:564) <Section background="/images/back_online.jpg" kind="gapless">
function create_default_slot_10(ctx) {
	let cta;
	let current;

	cta = new CTA({
			props: {
				name: "オンライン接客<br>実施中",
				overview: "ご来店が難しい方や不安な方のために、ビデオ通話によるオンライン接客を行っております。",
				action: "/online-service",
				color: "blue",
				position: "left"
			}
		});

	return {
		c() {
			create_component(cta.$$.fragment);
		},
		l(nodes) {
			claim_component(cta.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(cta, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(cta.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(cta.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(cta, detaching);
		}
	};
}

// (28:782) <Section background="/images/back_contact.jpg" kind="gapless">
function create_default_slot_9(ctx) {
	let ctcontact;
	let current;

	ctcontact = new CTContact({
			props: { color: "red", position: "right" }
		});

	return {
		c() {
			create_component(ctcontact.$$.fragment);
		},
		l(nodes) {
			claim_component(ctcontact.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(ctcontact, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(ctcontact.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(ctcontact.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(ctcontact, detaching);
		}
	};
}

// (28:1038) <Item columns="4">
function create_default_slot_8(ctx) {
	let newslink;
	let current;

	newslink = new NewsLink({
			props: { newsItem: /*item*/ ctx[5], reverse: true }
		});

	return {
		c() {
			create_component(newslink.$$.fragment);
		},
		l(nodes) {
			claim_component(newslink.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(newslink, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const newslink_changes = {};
			if (dirty & /*news*/ 8) newslink_changes.newsItem = /*item*/ ctx[5];
			newslink.$set(newslink_changes);
		},
		i(local) {
			if (current) return;
			transition_in(newslink.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(newslink.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(newslink, detaching);
		}
	};
}

// (28:1018) {#each news as item}
function create_each_block_1(ctx) {
	let item;
	let current;

	item = new Item({
			props: {
				columns: "4",
				$$slots: { default: [create_default_slot_8] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope, news*/ 1032) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(item, detaching);
		}
	};
}

// (28:1012) <List>
function create_default_slot_7(ctx) {
	let each_1_anchor;
	let current;
	let each_value_1 = /*news*/ ctx[3];
	let each_blocks = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		l(nodes) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(nodes);
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*news*/ 8) {
				each_value_1 = /*news*/ ctx[3];
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block_1(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				group_outros();

				for (i = each_value_1.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value_1.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (28:1006) <Wrap>
function create_default_slot_6(ctx) {
	let list;
	let current;

	list = new List({
			props: {
				$$slots: { default: [create_default_slot_7] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(list.$$.fragment);
		},
		l(nodes) {
			claim_component(list.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(list, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const list_changes = {};

			if (dirty & /*$$scope, news*/ 1032) {
				list_changes.$$scope = { dirty, ctx };
			}

			list.$set(list_changes);
		},
		i(local) {
			if (current) return;
			transition_in(list.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(list.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(list, detaching);
		}
	};
}

// (28:906) <Section name="お知らせ" en="NEWS" more="{['/news', 'すべてのお知らせを見る']}" background="/images/back_news.jpg">
function create_default_slot_5(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_6] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope, news*/ 1032) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (28:1274) <Item columns="2">
function create_default_slot_4(ctx) {
	let carlink;
	let current;
	carlink = new CarLink({ props: { car: /*item*/ ctx[5] } });

	return {
		c() {
			create_component(carlink.$$.fragment);
		},
		l(nodes) {
			claim_component(carlink.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(carlink, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const carlink_changes = {};
			if (dirty & /*cars*/ 16) carlink_changes.car = /*item*/ ctx[5];
			carlink.$set(carlink_changes);
		},
		i(local) {
			if (current) return;
			transition_in(carlink.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(carlink.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(carlink, detaching);
		}
	};
}

// (28:1254) {#each cars as item}
function create_each_block(ctx) {
	let item;
	let current;

	item = new Item({
			props: {
				columns: "2",
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope, cars*/ 1040) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(item, detaching);
		}
	};
}

// (28:1248) <List>
function create_default_slot_3(ctx) {
	let each_1_anchor;
	let current;
	let each_value = /*cars*/ ctx[4];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	return {
		c() {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
		},
		l(nodes) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(nodes);
			}

			each_1_anchor = empty();
		},
		m(target, anchor) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert(target, each_1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*cars*/ 16) {
				each_value = /*cars*/ ctx[4];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				group_outros();

				for (i = each_value.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			destroy_each(each_blocks, detaching);
			if (detaching) detach(each_1_anchor);
		}
	};
}

// (28:1242) <Wrap>
function create_default_slot_2(ctx) {
	let list;
	let current;

	list = new List({
			props: {
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(list.$$.fragment);
		},
		l(nodes) {
			claim_component(list.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(list, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const list_changes = {};

			if (dirty & /*$$scope, cars*/ 1040) {
				list_changes.$$scope = { dirty, ctx };
			}

			list.$set(list_changes);
		},
		i(local) {
			if (current) return;
			transition_in(list.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(list.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(list, detaching);
		}
	};
}

// (28:1141) <Section name="車両一覧" en="STOCK" more="{['/stock', 'すべての車両を見る']}" background="/images/back_stock.jpg">
function create_default_slot_1(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope, cars*/ 1040) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (28:238) <Page>
function create_default_slot(ctx) {
	let title;
	let if_block_anchor;
	let section0;
	let section1;
	let section2;
	let section3;
	let section4;
	let current;

	title = new Title({
			props: {
				title: "お問い合わせ",
				en: "CONTACT",
				background: "/images/back_contact_title.jpg"
			}
		});

	let if_block = /*thanks*/ ctx[0] && create_if_block(ctx);

	section0 = new Section({
			props: {
				$$slots: { default: [create_default_slot_11] },
				$$scope: { ctx }
			}
		});

	section1 = new Section({
			props: {
				background: "/images/back_online.jpg",
				kind: "gapless",
				$$slots: { default: [create_default_slot_10] },
				$$scope: { ctx }
			}
		});

	section2 = new Section({
			props: {
				background: "/images/back_contact.jpg",
				kind: "gapless",
				$$slots: { default: [create_default_slot_9] },
				$$scope: { ctx }
			}
		});

	section3 = new Section({
			props: {
				name: "お知らせ",
				en: "NEWS",
				more: ["/news", "すべてのお知らせを見る"],
				background: "/images/back_news.jpg",
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	section4 = new Section({
			props: {
				name: "車両一覧",
				en: "STOCK",
				more: ["/stock", "すべての車両を見る"],
				background: "/images/back_stock.jpg",
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(title.$$.fragment);
			if (if_block) if_block.c();
			if_block_anchor = empty();
			create_component(section0.$$.fragment);
			create_component(section1.$$.fragment);
			create_component(section2.$$.fragment);
			create_component(section3.$$.fragment);
			create_component(section4.$$.fragment);
		},
		l(nodes) {
			claim_component(title.$$.fragment, nodes);
			if (if_block) if_block.l(nodes);
			if_block_anchor = empty();
			claim_component(section0.$$.fragment, nodes);
			claim_component(section1.$$.fragment, nodes);
			claim_component(section2.$$.fragment, nodes);
			claim_component(section3.$$.fragment, nodes);
			claim_component(section4.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(title, target, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			mount_component(section0, target, anchor);
			mount_component(section1, target, anchor);
			mount_component(section2, target, anchor);
			mount_component(section3, target, anchor);
			mount_component(section4, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*thanks*/ ctx[0]) {
				if (if_block) {
					if (dirty & /*thanks*/ 1) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}

			const section0_changes = {};

			if (dirty & /*$$scope, endpoint, subject*/ 1030) {
				section0_changes.$$scope = { dirty, ctx };
			}

			section0.$set(section0_changes);
			const section1_changes = {};

			if (dirty & /*$$scope*/ 1024) {
				section1_changes.$$scope = { dirty, ctx };
			}

			section1.$set(section1_changes);
			const section2_changes = {};

			if (dirty & /*$$scope*/ 1024) {
				section2_changes.$$scope = { dirty, ctx };
			}

			section2.$set(section2_changes);
			const section3_changes = {};

			if (dirty & /*$$scope, news*/ 1032) {
				section3_changes.$$scope = { dirty, ctx };
			}

			section3.$set(section3_changes);
			const section4_changes = {};

			if (dirty & /*$$scope, cars*/ 1040) {
				section4_changes.$$scope = { dirty, ctx };
			}

			section4.$set(section4_changes);
		},
		i(local) {
			if (current) return;
			transition_in(title.$$.fragment, local);
			transition_in(if_block);
			transition_in(section0.$$.fragment, local);
			transition_in(section1.$$.fragment, local);
			transition_in(section2.$$.fragment, local);
			transition_in(section3.$$.fragment, local);
			transition_in(section4.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(title.$$.fragment, local);
			transition_out(if_block);
			transition_out(section0.$$.fragment, local);
			transition_out(section1.$$.fragment, local);
			transition_out(section2.$$.fragment, local);
			transition_out(section3.$$.fragment, local);
			transition_out(section4.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(title, detaching);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
			destroy_component(section0, detaching);
			destroy_component(section1, detaching);
			destroy_component(section2, detaching);
			destroy_component(section3, detaching);
			destroy_component(section4, detaching);
		}
	};
}

function create_fragment(ctx) {
	let head;
	let page;
	let current;

	head = new Head({
			props: {
				title: "お問い合わせ | 株式会社アルベロ | 群馬県の輸入車販売店",
				path: "/contact",
				description: "株式会社アルベロのお問い合わせページです。株式会社アルベロは、群馬県前橋市にある自動車販売店です。輸入車を中心に、高品質な車両を新車、中古車問わずどんな車両でも常時取り揃えております。自社工場も完備しているので、購入後のメンテナンスもお任せください。",
				image: "/images/keyvisual.jpg"
			}
		});

	page = new Page({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(head.$$.fragment);
			create_component(page.$$.fragment);
		},
		l(nodes) {
			claim_component(head.$$.fragment, nodes);
			claim_component(page.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(head, target, anchor);
			mount_component(page, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const page_changes = {};

			if (dirty & /*$$scope, cars, news, endpoint, subject, thanks*/ 1055) {
				page_changes.$$scope = { dirty, ctx };
			}

			page.$set(page_changes);
		},
		i(local) {
			if (current) return;
			transition_in(head.$$.fragment, local);
			transition_in(page.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(head.$$.fragment, local);
			transition_out(page.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(head, detaching);
			destroy_component(page, detaching);
		}
	};
}

const preload = contact;

function instance($$self, $$props, $$invalidate) {
	let { thanks = false } = $$props;
	let { subject } = $$props;
	let { endpoint } = $$props;
	let { news = [] } = $$props;
	let { cars = [] } = $$props;

	$$self.$$set = $$props => {
		if ("thanks" in $$props) $$invalidate(0, thanks = $$props.thanks);
		if ("subject" in $$props) $$invalidate(1, subject = $$props.subject);
		if ("endpoint" in $$props) $$invalidate(2, endpoint = $$props.endpoint);
		if ("news" in $$props) $$invalidate(3, news = $$props.news);
		if ("cars" in $$props) $$invalidate(4, cars = $$props.cars);
	};

	return [thanks, subject, endpoint, news, cars];
}

class Contact extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			thanks: 0,
			subject: 1,
			endpoint: 2,
			news: 3,
			cars: 4
		});
	}
}

export default Contact;
export { preload };
//# sourceMappingURL=contact.js.map
